import { useState, useRef, useEffect } from "react";
import { Container, Form, Button } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';

import CustomSelect from '../Compartido/CustomSelect.jsx';
import { useTranslation } from 'react-i18next';

import axios from 'axios';
import usePreciosCalendario from '../Compartido/usePreciosCalendario.js';
import '../../../../../css/web/hotelcamprodon/buscador.css';


const BuscadorBarrio = ({ barrio, barrios, destino, destinos, tiposcasas, lang, config, capacidad_maxima, noninos }) => {

    const { t } = useTranslation();

    if (lang == "es")
        registerLocale('es', es)
    else if (lang == "fr")
        registerLocale('fr', fr)
    else if (lang == "ca")
        registerLocale('ca', ca)
    else if (lang == "de")
        registerLocale('de', de)
    else
        registerLocale('es', es)

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    // 'yyyy-MM-dd' local (no toISOString: evita el desfase per zona horària),
    // mateixa clau que retorna PaginasController::preciosBuscadorGeneral.
    const fechaAPreciosKey = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    // Preus carregats a poc a poc (2 mesos cada cop) a mida que es navega
    // el calendari, en comptes de calcular-ho tot d'un cop.
    const { preciosPorDia, cargandoPrecios, carregarPreusMes } = usePreciosCalendario('/preciosbuscadorgeneral');

    const numpersonas = useRef(null);

    const toggleBlur = (shouldBlur) => {
        var elements = document.getElementsByClassName("potblur");
        if (shouldBlur) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].classList.add('blur');
            }
        } else {
            for (var i = 0; i < elements.length; i++) {
                elements[i].classList.remove('blur');
            }
        }
    };

    const [show, setShow] = useState('none');
    const handleShow = () => {
        if (show == 'none') {
            setShow('block');
            toggleBlur(true);
        }
        else {
            setShow('none');
            toggleBlur(false);
        }
    };

    // Barra fixa a peu de pàgina + popup a pantalla completa, només a
    // mòbil (reemplaça l'antic botó "Buscar"/"Esconder" que amagava el
    // formulari inline). Mateix patró que Inicio/Banner.jsx.
    const [sheetOpen, setSheetOpen] = useState(false);

    const resumFechas = () => {
        if (!startDate) return t("Elige fechas");
        const opciones = { day: 'numeric', month: 'short' };
        const inicio = startDate.toLocaleDateString(lang, opciones);
        if (!endDate) return inicio;
        const final = endDate.toLocaleDateString(lang, opciones);
        return inicio + ' - ' + final;
    };

    {/* ********************** */ }

    // Diverses habitacions, cadascuna amb el seu propi adults/nens — igual
    // que Inicio/Banner.jsx. Només és una manera més còmoda d'introduir els
    // números: per sota se segueix enviant un sol adultos/ninos (la suma de
    // totes les habitacions), cap canvi al cercador ni al backend.
    const [habitaciones, setHabitaciones] = useState([{ adultos: 1, ninos: 0 }]);

    const countAdults = habitaciones.reduce((total, hab) => total + hab.adultos, 0);
    const countNinos = habitaciones.reduce((total, hab) => total + hab.ninos, 0);

    const cambiarHabitacion = (index, campo, delta) => {
        setHabitaciones(prev => prev.map((hab, i) => {
            if (i !== index) return hab;
            const nuevoValor = hab[campo] + delta;
            if (campo === 'adultos' && nuevoValor < 1) return hab;
            if (campo === 'ninos' && nuevoValor < 0) return hab;
            const otroValor = campo === 'adultos' ? hab.ninos : hab.adultos;
            if (nuevoValor + otroValor > capacidad_maxima) return hab;
            return { ...hab, [campo]: nuevoValor };
        }));
    };

    const anadirHabitacion = () => {
        setHabitaciones(prev => [...prev, { adultos: 1, ninos: 0 }]);
    };

    const eliminarHabitacion = (index) => {
        setHabitaciones(prev => prev.length > 1 ? prev.filter((_, i) => i !== index) : prev);
    };

    useEffect(() => {
        let frase = t("Escoja personas");
        if (countAdults == 1) frase = " " + countAdults + " " + t("Adulto");
        if (countAdults > 1) frase = " " + countAdults + " " + t("Adultos");
        if (countNinos == 1) frase += " " + countNinos + " " + t("Niño");
        if (countNinos > 1) frase += " " + countNinos + " " + t("Niños");
        if (habitaciones.length > 1) frase += " · " + habitaciones.length + " " + t("Habitaciones");

        if (numpersonas.current) numpersonas.current.textContent = frase;
    }, [countAdults, countNinos, habitaciones.length]);

    const resumPersonas = () => countAdults + countNinos;

    const objeto0 = { id: -1, name: t("Todos"), value: "" }

    let resultsd = [];
    let resultstc = [];
    let optionchecked = "Destinos";

    resultsd = resultsd.concat(objeto0);
    destinos.forEach((undestino, index) => {
        let objeto = { id: index, name: undestino.elnombre, value: undestino.laurl }
        if (undestino.laurl == destino.laurl) optionchecked = undestino.elnombre;
        resultsd = resultsd.concat(objeto);
    })

    resultstc = resultstc.concat(objeto0);
    tiposcasas.forEach((untipo, index) => {
        let objeto = { id: index, name: untipo.nombre, value: untipo.id }
        resultstc = resultstc.concat(objeto);
    })

    {/* ********************** */ }

    const [results4, setResults4] = useState(null);
    const [optioncheckedb, setOptioncheckedb] = useState("Todos");
    const [realBarrio, setRealBarrio] = useState(barrio.id);

    useEffect(() => {
        if (barrios.length > 0) {
            let resultsbarrios = [];
            barrios.forEach((unbarrio, index) => {
                let objeto = { id: index, name: unbarrio.elnombre, value: unbarrio.id }
                if (unbarrio.id == barrio.id) setOptioncheckedb(unbarrio.elnombre);
                resultsbarrios = resultsbarrios.concat(objeto);
            })
            setResults4(resultsbarrios);
        }
    }, [])

    const buscabarrios = (destino) => {
        if (destino) {
            let token = document.getElementById('meta_token').getAttribute('content');

            const result = axios.post('/busca-barrios', {
                destino: destino
            }, {
                headers: {
                    'content-type': 'text/json',
                    'X-CSRF-TOKEN': token
                }
            })
                .then((response) => {
                    setResults4(null);

                    setRealBarrio(null);

                    let resultsbarrios = [];
                    if (response.data.length > 0) {
                        setOptioncheckedb("Todos");
                        resultsbarrios = resultsbarrios.concat(objeto0);
                        {
                            response.data.forEach((unbarrio, index) => {
                                let objeto = { id: index, name: unbarrio.elnombre, value: unbarrio.id }
                                resultsbarrios = resultsbarrios.concat(objeto);
                            })
                        }
                        setResults4(resultsbarrios);
                    }
                })
        }
        else {
            setResults4(null);
        }
    }

    {/* ********************** */ }

    const handleFocus = (e) => {
        const { target } = e;

        if (target) {
            target.readOnly = true;  // -------> this for all others
            target.blur(); //  ------> this for ios iphone
        }
    };

    const [cMeses, setCMeses] = useState(2);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1023);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (isMobile) {
            setCMeses(1);
        }
        else {
            setCMeses(2);
        }
    }, [isMobile, cMeses]);

    return (
        <Container className={"caixa-cercadors bh-buscador" + (sheetOpen ? " bh-buscador--sheet-open" : "")}>
            <button type="button" className="bh-mobile-trigger" onClick={() => setSheetOpen(true)}>
                <span className="bh-mobile-trigger__resum">
                    <i className="fa-solid fa-calendar-days"></i> {resumFechas()}
                    <span className="bh-mobile-trigger__separador"></span>
                    <i className="fa-solid fa-user-group"></i> {resumPersonas()}
                </span>
                <span className="bh-mobile-trigger__cta" style={{ background: config.color_corporativo_web }}>
                    <i className="fa-solid fa-magnifying-glass"></i> {t("Buscar")}
                </span>
            </button>

            {sheetOpen && <div className="bh-mobile-backdrop" onClick={() => setSheetOpen(false)}></div>}

            <Form className={"fondo-buscador caixa-seccions bh-mobile-sheet" + (sheetOpen ? " bh-mobile-sheet--open" : "")} method="get" action={"/" + preidioma + t("buscar")}>
                <div className="bh-mobile-sheet__header">
                    <span>{t("Buscar")}</span>
                    <button type="button" className="bh-mobile-sheet__close" onClick={() => setSheetOpen(false)} aria-label={t("Cerrar")}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div className="row">
                    <div className="col buscador-inputs bderecha">
                        <span className="titulobuscador"><i className="fa-solid fa-location-dot bh-search__icon"></i>{t("Destinos")}</span>
                        <CustomSelect
                            defaultText={optionchecked}
                            optionsList={resultsd}
                            nameInput="destino"
                            realInput={destino.laurl}
                            funcion={buscabarrios}
                            onOpen={() => toggleBlur(true)}
                            onClose={() => toggleBlur(false)}
                        />
                    </div>

                    {results4 && (
                        <div className="col buscador-inputs bderecha">
                            <span className="titulobuscador"><i className="fa-solid fa-map bh-search__icon"></i>{t("Barrios")}</span>
                            <CustomSelect
                                defaultText={optioncheckedb}
                                optionsList={results4}
                                nameInput="barrio"
                                realInput={realBarrio}
                                onOpen={() => toggleBlur(true)}
                                onClose={() => toggleBlur(false)}
                            />
                        </div>
                    )}
                    <div className="col buscador-inputs bderecha">
                        <span className="titulobuscador"><i className="fa-solid fa-house bh-search__icon"></i>{t("Tipo Alojamiento")}</span>
                        <CustomSelect
                            defaultText="Todos"
                            optionsList={resultstc}
                            nameInput="tipo_casa"
                            onOpen={() => toggleBlur(true)}
                            onClose={() => toggleBlur(false)}
                        />
                    </div>
                    <div className="col buscador-inputs bderecha">
                        <span className="titulobuscador"><i className="fa-solid fa-calendar-days bh-search__icon"></i>{t("Entrada - Salida")}</span>
                        <DatePicker
                            isClearable={true}
                            onChange={(update) => {
                                setDateRange(update);
                            }}
                            onCalendarOpen={() => {
                                toggleBlur(true);
                                carregarPreusMes(startDate || new Date(), cMeses);
                            }}
                            onCalendarClose={() => toggleBlur(false)}
                            onMonthChange={(date) => carregarPreusMes(date, cMeses)}
                            className="form-control mw201 cpointer noborder fs15"
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange={true}
                            monthsShown={cMeses}
                            dateFormat="dd/MM/yyyy"
                            minDate={new Date()}
                            placeholderText={t("DD/MM/YYYY - DD/MM/YYYY")}
                            locale={lang}
                            name="daterange"
                            autoComplete="off"
                            onFocus={handleFocus}
                            renderDayContents={(day, date) => {
                                const precio = preciosPorDia[fechaAPreciosKey(date)];
                                return (
                                    <>
                                        {day}
                                        <small className="bh-precio-dia-picker">
                                            {precio > 0
                                                ? Math.round(precio / 100) + '€'
                                                : cargandoPrecios
                                                    ? <span className="bh-precio-dia-picker__spinner"></span>
                                                    : ' '}
                                        </small>
                                    </>
                                );
                            }}
                            calendarContainer={({ className, children }) => (
                                <div className={className}>
                                    {cargandoPrecios && (
                                        <div className="bh-precios-spinner" aria-live="polite">
                                            <span className="bh-precios-spinner__dot"></span>
                                            {t("Cargando precios")}...
                                        </div>
                                    )}
                                    {children}
                                </div>
                            )}
                        >
                        </DatePicker>

                    </div>
                    <div className="col buscador-inputs">
                        <span className="titulobuscador"><i className="fa-solid fa-user-group bh-search__icon"></i>{t("Huéspedes")}</span>
                        <div onClick={handleShow} className="form-control numpersonas mw201 noborder" ref={numpersonas}>1 {t("Adulto")}</div>

                        {/* ********* */}

                        <div className={"formpersonas" + (habitaciones.length > 3 ? " formpersonas--horizontal" : "")} style={{ display: show }} onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) { setShow("none"); toggleBlur(false); } }} tabIndex="0" onMouseLeave={handleShow}>

                            <div className={"bh-habitaciones" + (habitaciones.length > 3 ? " bh-habitaciones--horizontal" : "")}>
                            {habitaciones.map((habitacion, index) => (
                                <div className="bh-habitacion" key={index}>
                                    {habitaciones.length > 1 && (
                                        <div className="bh-habitacion__header">
                                            <span className="bh-habitacion__titol">{t("Habitación")} {index + 1}</span>
                                            <button type="button" className="bh-habitacion__eliminar" onClick={() => eliminarHabitacion(index)}>
                                                {t("Eliminar habitación")}
                                            </button>
                                        </div>
                                    )}

                                    <div className="mt-2 row">
                                        <label className="col-md-6 col-6 etiqueta-formulari"> {t("Adultos")}<div className="mini-etiqueta-formulari">({t("Desde_12_años")})</div></label>
                                        <div className="col-md-4 col-6">
                                            <div className="mt-4 input-group">
                                                <span className="input-group-btn">
                                                    <button type="button" className="btn btn-xs btn-number boto-cercle" onClick={() => cambiarHabitacion(index, 'adultos', -1)}>
                                                        <span className="centrar-boto-cercle">
                                                            <svg viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg>
                                                        </span>
                                                    </button>
                                                </span>
                                                <input type="text" className="form-control input-number numero-persones" value={habitacion.adultos} readOnly={true} />
                                                <span className="input-group-btn">
                                                    <button type="button" className="btn btn-xs btn-number boto-cercle" onClick={() => cambiarHabitacion(index, 'adultos', 1)}>
                                                        <span className="centrar-boto-cercle">
                                                            <svg viewBox="0 0 24 24" role="img" aria-label="add" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }} >
                                                                <rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect>
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {noninos == 0 && (
                                        <>
                                            <div className="linia"></div>

                                            <div className="mt-3 row">
                                                <label className="col-md-6 col-6 etiqueta-formulari"> {t("Niños")}<div className="mini-etiqueta-formulari">({t("De_2_a_12_años")})</div></label>
                                                <div className="mt-2 col-md-4 col-6">
                                                    <div className="mt-3 input-group">
                                                        <span className="input-group-btn">
                                                            <button className="btn btn-xs btn-number boto-cercle" type="button" onClick={() => cambiarHabitacion(index, 'ninos', -1)}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                        <input type="text" className="form-control input-number numero-persones" value={habitacion.ninos} readOnly={true} />
                                                        <span className="input-group-btn">
                                                            <button className="btn btn-xs btn-number boto-cercle" type="button" onClick={() => cambiarHabitacion(index, 'ninos', 1)}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="add" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}>
                                                                        <rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect>
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))}
                            </div>

                            <input type="hidden" name="adultos" value={countAdults} />
                            <input type="hidden" name="ninos" value={countNinos} />

                            <input type="hidden" name="bebes" value="0" />
                            <input type="hidden" name="distribucion" value={habitaciones.map(h => h.adultos + "-" + h.ninos).join(";")} />

                            <div className="linia"></div>

                            <button type="button" className="bh-anadir-habitacion" onClick={anadirHabitacion}>
                                <i className="fa-solid fa-plus"></i> {t("Añadir habitación")}
                            </button>
                        </div>

                        {/* ********* */}
                    </div>
                    <div className="col buscador-inputs botonsubmit">
                        <Button variant="primary" size="md" type="submit" style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web, borderRadius: "4px", height: "50px", marginTop: "4px" }} className="submit-button-custom">
                            <span className="onlymobile">{t("Buscar")} </span><i className="fa-solid fa-magnifying-glass fs21"></i>
                        </Button>
                    </div>
                </div>
            </Form>

        </Container>
    );
}

export default BuscadorBarrio;
